import { Observable } from 'rxjs';

export interface ComponentCanDeactivate {
  canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

export const pendingChangesGuard = (
  component: ComponentCanDeactivate
): Observable<boolean> | Promise<boolean> | boolean => {
  return component.canDeactivate();
};
